module.exports = __webpack_public_path__ + "static/flags/BX-49a6dd0f80e711f27e7ead88f98e90af.gif";